import Loading from '../../../Common/Loading';
import { useProfessionalsChartsDataContext } from './hooks/useProfessionalsChartsDataContext';
import { AnnualEvolution } from './AnnualEvolution';
import { EvolutionByCbo } from './EvolutionByCbo';

export const Charts = () => {
    const { isLoading } = useProfessionalsChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <AnnualEvolution />
                <EvolutionByCbo />
            </div>
        </>
    );
};
